<template>
  <v-flex xs12 sm10 md8 lg7>
    <v-card class="mt-5 mb-5">
      <v-card-title primary-title>
        <div class="headline">Información Personal</div>
      </v-card-title>
      <v-card-text>
        <div class="form-alerts mb-3">
          <v-layout row justify-space-around wrap>
            <v-flex xs12 sm10>
              <v-alert color="error" icon="warning" v-model="alert">{{ alertMessage }}</v-alert>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row justify-space-around wrap>
          <v-flex xs8>
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Nombre Completo"
                :counter="44"
                v-model="uppercasedFullName"
                :rules="fullNameRules"
                required
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout row justify-space-around wrap>
          <v-flex xs8>
            <v-list>
              <v-subheader>Correos Electrónicos</v-subheader>
              <v-list-tile v-if="!client || client.emails.length === 0">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>No hay correos electrónicos para mostrar</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-tile>
              <v-list-tile v-else v-for="(email, index) in client.emails" :key="index" @click="fix">
                <v-list-tile-content>
                  <v-list-tile-title>{{ email.address }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="!email.active">
                  <v-tooltip bottom>
                    <v-btn icon slot="activator">
                      <v-icon color="amber">warning</v-icon>
                    </v-btn>
                    <span>Activa tu correo electrónico</span>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon :loading="removingEmail" @click="$emit('remove-email', { email: email.address })">
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
        <v-layout row justify-space-around wrap>
          <v-flex xs8>
            <v-form v-model="emailIsValid" ref="emailForm">
              <v-layout row>
                <v-text-field
                  label="Nuevo Correo Electrónico"
                  v-model="emailAddress"
                  :rules="emailAddressRules"
                  :loading="creatingEmail"
                  required
                ></v-text-field>
                <v-btn
                  @click="submitEmail"
                  :loading="creatingEmail"
                  class="ml-3 mt-3"
                  fab
                  small
                  dark
                  color="green"
                >
                  <v-icon dark medium>add</v-icon>
                </v-btn>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="clear">Limpiar</v-btn>
        <v-btn
          flat
          success
          @click="submit"
          :loading="loading"
          :disabled="loading"
        >Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'personal-data',
  props: {
    client: Object,
    loading: Boolean,
    creatingEmail: Boolean,
    removingEmail: Boolean
  },
  data: function () {
    return {
      alert: false,
      alertMessage: '',
      valid: false,
      emailIsValid: false,
      fullName: '',
      fullNameRules: [
        (value) => !!value || 'Nombre completo requerido',
        (value) => (value && value.length <= 44) || 'El nombre completo debe contener menos de 44 caracteres',
        (value) => /^[a-zA-Zá-úÁ-ÚüÜ ]+$/.test(value) || 'Nombre completo inválido'
      ],
      emailAddress: '',
      emailAddressRules: [
        (value) => !!value || 'Correo electrónico requerido',
        (value) => /^([a-z0-9_.-]+)@([a-z0-9.-]+)\.([a-z.]{2,6})$/.test(value) || 'Correo electrónico inválido'
      ]
    }
  },
  computed: {
    uppercasedFullName: {
      get: function () {
        return this.fullName.toUpperCase()
      },
      set: function (fullName) {
        this.fullName = fullName
      }
    }
  },
  watch: {
    client: function (client) {
      this.fullName = client.name
    }
  },
  methods: {
    submit: function () {
      const form = this.$refs.form
      if (form.validate()) {
        this.$emit('update-personal-data', { name: this.uppercasedFullName })
        this.alert = false
      }
    },
    submitEmail: function () {
      const emailForm = this.$refs.emailForm
      if (emailForm.validate()) {
        this.$emit('create-email', { email: this.emailAddress })
        this.alert = false
        this.$refs.emailForm.reset()
      }
    },
    clear: function () {
      this.alert = false
      this.$refs.form.reset()
      this.$refs.emailForm.reset()
    },
    openAlert: function (message) {
      this.alertMessage = message
      this.alert = true
    },
    fix: function () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/PersonalData.vue